/* eslint-disable new-cap */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import ABCyaLib from '@abcya/abcya_lib';

export default class Intro extends Phaser.Scene {
  static get KEY() { return 'Intro'; }

  create() {
    this.cameras.main.setBackgroundColor('#FFFFFF');

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);
    this.player = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.curGoFrame = 0;

    this.checkerHeader = ABCyaPhaser.Images.addImage(0, 0, 'CheckeredHeader', this).setOrigin(0, 0);
    this.checkerFooter = ABCyaPhaser.Images.addImage(0, this.mid.y * 2, 'CheckeredHeader', this).setScale(1, -1)
      .setOrigin(0, 0);

    this.flagContainer = this.add.container();
    this.flagleft = ABCyaPhaser.Images.addImage(0, 0, 'CheckeredFlagIcon', this.flagContainer).setOrigin(0, 0);
    this.flagleft.x = 620;
    this.flagleft.y = 120;
    this.flagright = ABCyaPhaser.Images.addImage(0, 0, 'CheckeredFlagIcon', this.flagContainer).setOrigin(0, 0);
    this.flagright.scaleX = -1;
    this.flagright.x = 620 + this.flagright.getBounds().width * 2;
    this.flagright.y = 120;

    this.flagContainer.x = this.mid.x * 2;
    this.flagContainer.alpha = 0;

    let sn = '';
    let color;
    if (Phaser.Math.Between(0, 100) > 50) {
      gameData.coinmode = 'odd';
      sn = 'intro.odd';
      color = 0x980b0d;
      if (gameData.GAME_TYPE === 'jr') {
        sn = 'intro.silver';
        color = 0xcccfd1;
      }
    }
    else {
      sn = 'intro.even';
      color = 0x980b0d;
      gameData.coinmode = 'even';
      if (gameData.GAME_TYPE === 'jr') {
        sn = 'intro.gold';
        color = 0xf4bc44;
      }
    }

    const convertedString = ABCyaPhaser.Localization.instance.getLocalizedString(sn).replace('$', '');

    this.lblInst = this.addCustomColoredText(this, 720, this.flagright.y + this.flagright.getBounds().height + 43, 24, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString(sn), color, this.flagContainer);

    this.controlsContainer = this.add.container();
    this.controlsContainer.x = 720;
    this.controlsContainer.y = this.lblInst.y + 80;

    this.lblAccelerateInst = this.add.bitmapText(ABCyaLib.Environment.instance.gameConfig.intro.touchX, -10, 'asapReg', ABCyaPhaser.Localization.instance.getLocalizedString('intro.touch'), ABCyaLib.Environment.instance.gameConfig.intro.touchSize).setOrigin(.5)
      .setMaxWidth(470)
      .setCenterAlign();
    this.controlsContainer.add(this.lblAccelerateInst);
    this.lblAccelerateInst.alpha = 0;
    this.accelerateIcon = ABCyaPhaser.Images.addImage(0, 0, 'TouchIcon', this.controlsContainer).setAlpha(0);

    this.accelerateIcon.y = 40;
    this.accelerateHand = ABCyaPhaser.Images.addImage(0, 0, 'HelperHand', this.controlsContainer);
    this.accelerateHand.alpha = 0;

    this.accelerateHand.x = 5;
    this.accelerateHand.y = 70;

    this.steerInst = this.add.bitmapText(ABCyaLib.Environment.instance.gameConfig.intro.steerX, 145, 'asapReg', ABCyaPhaser.Localization.instance.getLocalizedString('intro.steer'), ABCyaLib.Environment.instance.gameConfig.intro.steerSize).setOrigin(.5)
      .setMaxWidth(470)
      .setCenterAlign();
    this.controlsContainer.add(this.steerInst);

    this.steerInst.alpha = 0;
    this.steerIcon = ABCyaPhaser.Images.addImage(0, 0, 'SteerArrows', this.controlsContainer);
    this.steerIcon.alpha = 0;
    this.steerIcon.y = 190;
    this.steerHand = ABCyaPhaser.Images.addImage(0, 0, 'HelperHand', this.controlsContainer).setOrigin(0, 0);
    this.steerHand.x = -40;
    this.steerHand.y = 178;
    this.steerHand.alpha = 0;

    this.btnGo = this.add.container(0, -180);
    const btnGoBG = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'BtnGo', null, () => {
      btnGoBG.setEnabled(false);
      this.onClickGo();
    }, this.btnGo, { disabledTint: '0xFFFFFF' }).setEnabled(false);
    const btnTxt = this.add.bitmapText(0, -4, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('buttons.go'), 48).setTintFill('0xFFFFFF')
      .setOrigin(.5);
    this.btnGo.add(btnTxt);

    this.bigCar = ABCyaPhaser.Images.addImage(0, 0, 'BigCar', this);
    this.bigCar.x = this.mid.x * 2 + 220;
    this.bigCarDestY = 380;
    this.bigCar.y = this.mid.y * 2 - 200;
    this.bigCar.rotation = -90;

    this.layoutRatio();

    if (gameData.queueBusy) {
      // We aren't ready to start the game yet
      gameData.queueCompleteHandler = this.doCarIntro.bind(this);
    }
    else {
      this.doCarIntro();
    }
  }

  /**
   * Creates a custom bitmapText field and colors in certain words marked by special tags within the string.
   * @param {Phaser.Scene} scene 
   * @param {Number} x 
   * @param {Number} y 
   * @param {Number} size font size
   * @param {String} font bitmap font key
   * @param {String} string text string
   * @param {String} color String hex value. Can be an array or single string
   * @param {Phaser.GameObjects.Container} container optional container to add the text to
   * @param {Number} origin optional origin. Set to .5 (center) by default
   * @returns the bitmapText field
   */
  addCustomColoredText(scene, x, y, size, font, string = '', color = '0x000000', container = null, origin = .5) {
    let pos = 0;
    let wordCount = 0;
    const startInds = [];
    const endInds = [];

    // Loop to check all start occurrences 
    while (string.indexOf('[', pos) !== -1) {
      startInds.push(string.indexOf('[' , pos));
      pos = string.indexOf('[' , pos) + 1;
      wordCount++;
    }

    // Loop to check all end occurrences 
    pos = 0;
    while (string.indexOf(']', pos) !== -1) {
      endInds.push(string.indexOf(']' , pos) - 1);
      pos = string.indexOf(']' , pos) + 1;
    }

    // remove the special tags from the string
    const convertedString = string.replace(/[[\]]/g, '');

    // create the bitmapText field
    const text = scene.add.bitmapText(x, y, font, convertedString, size).setOrigin(origin);
    if (container) container.add(text);

    // for each set of special tags, colorize the characters within the tags.
    for (let i = 0; i < wordCount; i++) {
      const wordLen = endInds[i] - startInds[i];
      let colorToUse;
      if (wordCount === 1) {
        // if there is only 1 special word, and more than 1 color, choose a random color from the array.
        colorToUse = color.length > 0 ? color[Phaser.Math.Between(0, color.length - 1)] : color;
      }
      else {
        // match the color to the word unless there's only 1 color.
        colorToUse = color.length > 0 ? color[i] : color;
      }

      // find the new starting points in the converted string for each colored word.
      const startInd = startInds[i] - (2 * i);
      text.setCharacterTint(startInd, wordLen, colorToUse, colorToUse);
    }

    return text;
  }

  doCarIntro() {
    ABCyaPhaser.Audio.playOneShot('car_passby_fast_brake', this);

    this.carRotationTween = ABCyaPhaser.Tweens.addTween(this.bigCar, 880, { delay: 320, angle: 30 }, Phaser.Math.Easing.Quadratic.Out);
    this.carMoveTween = ABCyaPhaser.Tweens.addTween(this.bigCar, 1200, { x: 200, y: this.bigCarDestY }, Phaser.Math.Easing.Quadratic.Out);

    this.time.delayedCall(800, () => { this.doTitleIntro(); });
  };

  doTitleIntro() {
    ABCyaPhaser.Tweens.addTween(this.flagContainer, 420, { x: 0, alpha: 1 }, Phaser.Math.Easing.Linear);

    const snd = null;
    if (gameData.coinmode === 'even') {
      if (gameData.GAME_TYPE === 'jr') {
        ABCyaPhaser.Audio.playSound('raceway_collect_all_gold_coins', this.player);
      }
      else {
        ABCyaPhaser.Audio.playSound('raceway-09', this.player);
      }

    }
    else {
      if (gameData.GAME_TYPE === 'jr') {
        ABCyaPhaser.Audio.playSound('raceway_collect_all_silver_coins', this.player);
      }
      else {
        ABCyaPhaser.Audio.playSound('raceway-10', this.player);
      }
    }
    this.player.once('complete', () => { this.doTouchIntro(); });
  };

  doTouchIntro() {
    ABCyaPhaser.Tweens.addTween(this.lblAccelerateInst, 200, { alpha: 1 }, Phaser.Math.Easing.Linear);

    ABCyaPhaser.Tweens.addTween(this.accelerateIcon, 500, { scale: 1.2, alpha: 1, yoyo: true, repeat: -1, repeatDelay: 200 }, Phaser.Math.Easing.Linear);

    this.accelerateHand.scale = 0.8;
    this.accelerateHand.alpha = 1;

    ABCyaPhaser.Tweens.addTween(this.accelerateHand, 500, { scale: .7, yoyo: true, repeat: -1, repeatDelay: 200 }, Phaser.Math.Easing.Linear);

    ABCyaPhaser.Audio.playSound('raceway_drive_directions_1', this.player);
    this.player.once('complete', () => { this.doSlideIntro(); });
  };

  doSlideIntro() {
    ABCyaPhaser.Audio.playSound('raceway_drive_directions_2', this.player);
    this.player.once('complete', () => { this.doGoButtonIntro(); });

    ABCyaPhaser.Tweens.addTween(this.steerInst, 200, { alpha: 1 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.steerIcon, 320, { delay: 200, alpha: 1 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.steerHand, 320, { delay: 200, alpha: 1 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.steerHand, 500, { x: -20, yoyo: true, repeat: -1, repeatDelay: 800 }, Phaser.Math.Easing.Linear);
  };

  doGoButtonIntro() {
    ABCyaPhaser.Audio.playOneShot('car_screech_short', this);

    ABCyaPhaser.Tweens.addTween(this.btnGo, 600, { x: this.mid.x - 120 }, Phaser.Math.Easing.Quadratic.Out, () => { this.btnGo.list[0].setEnabled(true); });
  };

  onClickGo() {
    this.scene.start('Game');
  };

  layoutRatio() {
    this.checkerFooter.y = this.mid.y * 2;
    this.btnGo.x = -this.btnGo.getBounds().width / 2;
    this.btnGo.y = this.mid.y * 2 - this.btnGo.getBounds().height / 2 - 128;

    const scale = 1.0;
    this.bigCarDestY = 380;
    this.flagContainer.y = 0;
    this.controlsContainer.y = this.lblInst.y + 80;
    this.controlsContainer.scale = scale;
    this.bigCar.scale = scale;
    this.bigCar.y = this.bigCarDestY;
  };
}